export const settingAccommodation = {
    p1: `Informacje podstawowe`,
    p2: `Wprowadź nazwę i logo, które użytkownicy zobaczą po rozpoczęciu procesu check-in. W razie braku własnego logo zostanie użyte domyślne logo WACheckin.`,
    p3: `Regulamin obiektu`,
    p4: `Dostosuj regulamin swojego obiektu. To będą warunki, które goście zaakceptują podczas check-in.`,
    p5: `HISZPAŃSKI`,
    p6: `ANGIELSKI`,
    p7: `Wiadomość powitalna`,
    p8: `Dostosuj wiadomość powitalną, którą goście zobaczą po ukończeniu check-in.`,
    p9: `Klucze do pokoi`,
    p10: `Rejestruj pokoje wyposażone w inteligentne zamki i zarządzaj nimi. Skonfiguruj kody dostępu przekazywane gościom po check-in, aby ułatwić im wejście.`,
    p11: `Właściwe organy`,
    p12: `Skonfiguruj połączenie z lokalnymi organami, aby automatycznie wysyłać raporty o podróżnych. Wprowadź nazwę użytkownika i hasło do platformy każdego właściwego organu.`,
    p13: `Guardia Civil`,
    p14: `Policía Nacional`,
    p15: `Ertzaintza`,
    p16: `Mossos`,
    p17: `dane dostępowe`,
    p18: `Instytucja jest wymagana`,
    p19: `Nazwa użytkownika jest wymagana`,
    p20: `Hasło jest wymagane`,
    p21: `Błąd podczas próby weryfikacji danych`,
    p22: `Instytucja jest wymagana`,
    p23: `Nazwa użytkownika jest wymagana`,
    p24: `Hasło jest wymagane`,
    p25: `Dane zaktualizowane pomyślnie`,
    p26: `Błąd podczas wprowadzania danych policji imigracyjnej`,
    p27: `Pobierz kod QR swojego obiektu, aby przyspieszyć check-in, lub skopiuj link do wysłania bezpośrednio gościom.`,
    p28: `Edytuj kod bezpieczeństwa obiektu`,
    p29: `Weryfikujemy tożsamość gości, porównując zdjęcie ich dowodu lub paszportu z selfie wykonanym na żywo.`,
    p30: `Po włączeniu tej opcji goście będą musieli zweryfikować swoją tożsamość podczas procesu check-in. Jeśli weryfikacja nie zakończy się pomyślnie, nie będą mogli kontynuować check-in.`,
    p31: `Błąd podczas aktywacji weryfikacji tożsamości`,
    p32: `Ustawienia płatności`,
    p33: `Pobieraj płatności od gości podczas procesu check-in, umożliwiając im opłacenie usług dodatkowych i należnych opłat.`,
    p34: `Kod bezpieczeństwa obiektu`,
    p35: `Obiekt`,
    p36: `Włącz tę opcję, aby w dniu check-out automatycznie wysyłać wiadomość WhatsApp z prośbą o ocenę pobytu w obiekcie w skali od 1 do 5.`,
    p37: `Wprowadź adres URL serwisu z opiniami, w którym goście mają zostawiać swoje opinie, czy to w Google, czy w innym używanym serwisie. Pomaga to poprawić widoczność i reputację obiektu.`,
    p38: `Wprowadź adres URL serwisu z opiniami (np. Google, TripAdvisor)`,
    p39: `Zarządzaj swoim obiektem`,
    p40: `Informacje podstawowe`,
    p41: `Regulamin obiektu`,
    p42: `Wiadomość powitalna`,
    p43: `Kod QR obiektu`,
    p44: `Płatności gości`,
    p45: `Prześlij logo obiektu`,
    p46: `Możesz przesłać lub przeciągnąć obraz do pola`,
    p47: `Wygląd`,
    p48: `Regulamin`,
    p49: `Powitanie`,
    p50: `Region`,
    p51: `Hiszpański`,
    p52: `Angielski`,
    p53: `Arabski`,
    p54:``,
    p55:``,
    p56:``,
    p57:``,
    p58:``,
    p59:``,
    p60:``,
    p61:``,
    p62:``,
    p63:``,
    p64:``,
    p65:``,
    p66:``,
    p67:``,
    p68:``,
    p69:``,
    p70:``,
};
